module.exports = __webpack_public_path__ + "img/trusteeship.16f86fc3.png";